//for debug mode
export const API_BASE_URL="https://jdihxdr0aa.execute-api.us-east-1.amazonaws.com/dev/"; // for the app deployement

 // For prod2 Mode URL
// export const API_BASE_URL =
//   "https://thegugylr1.execute-api.us-east-1.amazonaws.com/prod2/"; //root module
// export const BASE_URL_MASTER =
//   "https://lbjylpbgxe.execute-api.us-east-1.amazonaws.com/prod2/"; //module
// export const BASE_URL =
//   "https://u59mnt6ibk.execute-api.us-east-1.amazonaws.com/prod2/"; // module 2
export const BASE_URL2 =
  "https://sx22xezo22.execute-api.us-east-1.amazonaws.com/prod2/"; //module 3



export const GET_ALL_USERS = API_BASE_URL + "users/";

export const GET_ALL_TOURS = API_BASE_URL + "tour/";
export const GET_ALL_LISTING = API_BASE_URL + "tour/tourist/";
export const GET_TOUR_DETAILS = API_BASE_URL + "tour/";
export const GET_PUBLISHED_TOURS = BASE_URL2 + "tour/published";
export const GLOBAL_ADVANCE_NOTICE_DAYS_BEFORE_BOOKING = "7";